import { useGoogleAnalytics } from '@/hooks/use-google-analytics';

/** Renders nothing: mounts the analytics hook inside the router. */
export function AnalyticsTracker() {
  useGoogleAnalytics();
  return null;
}
